import { render, staticRenderFns } from "./ShowBasic.vue?vue&type=template&id=284550bd&scoped=true&"
import script from "./ShowBasic.vue?vue&type=script&lang=ts&"
export * from "./ShowBasic.vue?vue&type=script&lang=ts&"
import style0 from "./ShowBasic.vue?vue&type=style&index=0&id=284550bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284550bd",
  null
  
)

export default component.exports